import { FieldHandler, FieldIssueContext, registerFieldHandler } from './fieldHandlers';
import { taskService } from '../TaskManagement/taskService';

// Parse authorized signers from defaultValue (JSON array or delimited string)
function parseAuthorized(raw: any): string[] {
  if (!raw) return [];
  try {
    if (typeof raw === 'string') {
      const arr = JSON.parse(raw);
      return Array.isArray(arr)
        ? arr.map(String).map((s) => s.trim()).filter(Boolean)
        : raw.split(/[;,:\s]+/).map((s) => s.trim()).filter(Boolean);
    }
    if (Array.isArray(raw)) return raw.map(String).map((s) => s.trim()).filter(Boolean);
    return [];
  } catch {
    if (typeof raw === 'string') return raw.split(/[;,:\s]+/).map((s) => s.trim()).filter(Boolean);
    return [];
  }
}

const signatureHandler: FieldHandler = {
  async onIssue(ctx: FieldIssueContext): Promise<boolean> {
    const fieldName = String(ctx?.fieldDef?.name || '').trim();
    if (!fieldName) return false;

    // Skip if already signed
    const currentVal = (ctx.mergedFields as any)?.[fieldName];
    const isAlreadySigned = typeof currentVal === 'string' && currentVal.trim().length > 0;
    if (isAlreadySigned) return false;

    const authorized = parseAuthorized(ctx?.fieldDef?.defaultValue);
    if (!authorized.length) return false;

    const formNum = ctx.formNum || (ctx.formRecord?.form_num ?? 'N/A');
    const formDesc = ctx.formDesc || (ctx.formRecord?.form_description ?? 'Form');

    const description = `Form Approval: ${formNum} - ${formDesc} — field:${fieldName}`;
    const context = { kind: 'signature', field: fieldName, form_record_id: Number(ctx.formRecord?.id) || undefined };
    const isSequential = (ctx.strategy || 'parallel') === 'sequential';
    const seq = Number(ctx.sequence || 1);
    const client_key = `sig:${context.form_record_id}:${fieldName}:${isSequential ? seq : 'p'}`;

    await taskService.issueSignatureApproval({
      formRecordId: Number(ctx.formRecord?.id) || undefined,
      fieldName,
      assignees: authorized,
      navigateTo: ctx.navigateTo,
      description,
      sequential: isSequential,
      sequence: seq,
      clientKey: client_key,
      fanoutPerAssignee: true,
    });
    return true;
  },

  async onComplete(currentTaskId: number, actingPersonnelId: string) {
    await taskService.completeTaskAndUnblockNext(currentTaskId, actingPersonnelId);
  },
};

// Register on import
registerFieldHandler('signature', signatureHandler);

export default signatureHandler;
